/**
 * Constants for MsCheckbox component
 * Các hằng số cho component MsCheckbox
 */

// CSS Classes
export const CSS_CLASSES = {
  wrapper: 'ms-checkbox',
  control: 'ms-checkbox-control',
  text: 'ms-checkbox--text',
  eventNone: 'event-none'
}

// Default prop values
export const DEFAULT_PROPS = {
  modelValue: false,
  label: null,
  disabled: false,
  readOnly: false,
  checked: false,
  isShowLabel: true
}

// Event names
export const EVENTS = {
  UPDATE_MODEL_VALUE: 'update:modelValue',
  CHANGE: 'change', 
  CHECKED_CHANGE: 'checkedChange',
  FOCUS: 'focus',
  BLUR: 'blur',
  CLICK: 'click'
}
